import {
  CalendarData,
  ChangeEvent,
  DynamicContentType,
} from '@bm-js/atlascloud-shared'
import Select from './Select'
import { marginOptions } from '@bm-js/atlascloud-ui'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

type Props = {
  content: DynamicContentType<CalendarData>
  setData: (e: ChangeEvent) => void
}

const CalendarEditor = ({ content, setData }: Props) => {
  const { tr } = useTr()

  return (
    <>
      <Select
        light
        label={tr(TrKey.calendarEditorMarginBottomLabel)}
        desc={tr(TrKey.calendarEditorMarginBottomDescription)}
        id='marginBottom'
        name='marginBottom'
        value={content.data.marginBottom}
        onChange={setData}
      >
        <option value='' disabled>
          {tr(TrKey.calendarEditorMarginBottomPlaceholder)}
        </option>
        {marginOptions.map((opt) => (
          <option key={`margin_option_${opt.value}`} value={opt.value}>
            {opt.name}
          </option>
        ))}
      </Select>
    </>
  )
}

export default CalendarEditor
